import { ReactNode, useContext } from 'react';

import { Box } from '../Box/Box';

import { listContext } from '../List/context';
import { listItemStyle } from './ListItem.css';

export interface ListItemProps {
  children: ReactNode;
  onClick?: () => void;
  interactive?: boolean;
  primaryAction?: ReactNode;
}

export const ListItem: React.FC<React.PropsWithChildren<ListItemProps>> = ({
  children,
  onClick,
  interactive = true,
  primaryAction,
}) => {
  const { rounded } = useContext(listContext);
  return (
    <Box
      component={onClick ? 'button' : undefined}
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      display="flex"
      alignItems="center"
      justifyContent="spaceBetween"
      background="body"
      padding="medium"
      borderRadius={rounded ? 'large' : undefined}
      width="full"
      className={interactive ? listItemStyle : ''}
    >
      <Box display="flex" alignItems="center" paddingRight="large">
        {children}
      </Box>
      {primaryAction}
    </Box>
  );
};
